module.exports = function($, EQ, EDD) {
    class Vote {

        constructor() {
            this.total = 17;
            this.bulletinVote = {
                vote: 0,
                list: 0,
                results: {
                    lists: [],
                    candidats: []
                },
                start: false,
                status: ''
            };

            this.LetzvoteEuropeennes = (typeof LetzvoteEuropeennes != 'undefined')? LetzvoteEuropeennes : {};

            this.init();
            this.bind();
            this.markup_vote();
        }

        init(){

            this.Container = $('.page-template-tpl-europeennes .block-pratique-vote');

            if( this.Container.length == 0 ){
                return;
            }

            let s = sessionStorage.getItem('EuropeennesVote');
            if (s) {
                this.bulletinVote = JSON.parse(s);
            }
            this.load();
        }

        load(){
            let s = sessionStorage.getItem('LetzvoteEuropeennes');
            if( s ){
                this.LetzvoteEuropeennes = JSON.parse(s);
            }
        }

        clear_all(){
            this.bulletinVote = {
                vote: 0,
                list: 0,
                results: {
                    lists: [],
                    candidats: []
                },
                start: false,
                status: ''
            };
            this.LetzvoteEuropeennes.score = 0;
            this.LetzvoteEuropeennes.trials = {
                bulletinVote: 0,
                quizz: 0,
                dragandrop: 0
            };

            // this.LetzvoteEuropeennes.trials.bulletinVote = 0;
            // this.LetzvoteEuropeennes.trials.quizz = 0;
            // this.LetzvoteEuropeennes.trials.dragandrop = 0;
            this.LetzvoteEuropeennes.number = 0;

            sessionStorage.setItem('EuropeennesVote', JSON.stringify(this.bulletinVote) );
            sessionStorage.setItem('LetzvoteEuropeennes', JSON.stringify(this.LetzvoteEuropeennes) );

            EQ.clear_all();
            EDD.clear_all();
            this.markup_vote();

            $('[data-group="pratique"]').removeClass('active');
            $('#pratique--1').addClass('active');
        }

        bind(){
            // let _array = [];
            let _this = this;

            this.Container.find('.social a').on('click', function(e){
                e.preventDefault();
                let onclick = $(this).attr('href');
                onclick = onclick.replace('X', _this.LetzvoteEuropeennes.score);
                window.open(onclick, '_blank', ',width=600,height=600');
            });

            this.Container.find('.clear-all').on('click', function(e){
                _this.clear_all();
            })

            this.Container.find('.submit-bulletin-vote').on('click', function(e){
                e.preventDefault();
                _this.vote_resolve();
            });

            this.Container.find('.candidat-vote').on('click', function(e){
                $(this).toggleClass('checked');
                if( $(this).hasClass('checked') ){
                    _this.bulletinVote.vote += 1;
                } else {
                    _this.bulletinVote.vote -= 1;
                }
                let candidat = $(this).attr('data-candidat');
                let vote = $(this).attr('data-vote');
                let list = $(this).attr('data-list');
                let _class = `list-${list}-candidat-${candidat}-vote-${vote}`;
                if(_this.bulletinVote.results.candidats.includes(_class) ){
                    let index = _this.bulletinVote.results.candidats.indexOf(_class);
                    _this.bulletinVote.results.candidats.splice(index, 1);
                } else {
                    _this.bulletinVote.results.candidats.push(`list-${list}-candidat-${candidat}-vote-${vote}`);
                }

                sessionStorage.setItem('EuropeennesVote', JSON.stringify(_this.bulletinVote) );

                _this.markup_vote();
            });

            this.Container.find('.list-vote').on('click', function(){
                $(this).toggleClass('checked');
                if( $(this).hasClass('checked') ){
                    _this.bulletinVote.list += 1;
                } else {
                    _this.bulletinVote.list -= 1;
                }
                let list = $(this).attr('data-list');
                if(_this.bulletinVote.results.lists.includes(list) ){
                    let index = _this.bulletinVote.results.lists.indexOf(list);
                    _this.bulletinVote.results.lists.splice(index, 1);
                } else {
                    _this.bulletinVote.results.lists.push(list);
                }
                sessionStorage.setItem('EuropeennesVote', JSON.stringify(_this.bulletinVote) );
                _this.markup_vote();
            });

            this.Container.find('.clear-bulletinVote').on('click', function(e){
                e.preventDefault();
                _this.bulletinVote = {
                    vote: 0,
                    list: 0,
                    results: {
                        lists: [],
                        candidats: []
                    },
                    start: true,
                    status: ''
                };

                if( _this.LetzvoteEuropeennes.trials.bulletinVote != 0 ){
                    _this.LetzvoteEuropeennes.score -= _this.total;
                }
                _this.LetzvoteEuropeennes.trials.bulletinVote = 0;
                _this.LetzvoteEuropeennes.number -= 1;

                sessionStorage.setItem('EuropeennesVote', JSON.stringify(_this.bulletinVote) );
                sessionStorage.setItem('LetzvoteEuropeennes', JSON.stringify(_this.LetzvoteEuropeennes) );

                $("html, body").animate({ scrollTop: $('.block-pratique').offset().top - 100 }, 400 );
                _this.markup_vote();
            });
        }

        markup_vote(){
            // console.log(this.bulletinVote);
            if( this.Container.length == 0 ){
                return;
            }

            let _this = this;
            if( this.bulletinVote.start == true ){
                this.Container.find('.bubble-1').addClass('active');
                this.Container.find('.grids').addClass('active');
            }

            let voix = 6 - this.bulletinVote.vote;
            if( this.bulletinVote.list > 0 ){
                voix = 0;
            }
            voix = (voix<0)? 0 : voix;
            voix +=  '/' + 6;
            this.Container.find('.tongue span').text(voix);

            this.Container.find('.list-vote').removeClass('checked');
            for (let j in this.bulletinVote.results.lists) {
                this.Container.find('.list-vote[data-list="'+this.bulletinVote.results.lists[j]+'"]').addClass('checked');
            }

            this.Container.find('.candidat-vote').removeClass('checked');
            for (let j in this.bulletinVote.results.candidats) {
                this.Container.find(`.candidat-vote.${this.bulletinVote.results.candidats[j]}`).addClass('checked');
            }

            this.Container.find('.grid-item-row').addClass('d-none');
            for(let i=1; i<=6;i++){
                this.Container.find('.grid-item-row-'+i).removeClass('d-none');
            }

            this.Container.find('.grid-item').addClass('d-none');
            for (let k=1; k<=2; k++) {
                this.Container.find(`.grid-item.list-${k}`).removeClass('d-none');
            }

            if( this.LetzvoteEuropeennes.score < this.LetzvoteEuropeennes.total / 2 ){
                this.Container.find('.content-global').removeClass('d-none');
            } else {
                this.Container.find('.content-global').addClass('d-none');
            }

            if( this.bulletinVote.status == 'failed' ){
                this.Container.find('.note').text("0 / " + this.total);
                this.Container.find('.message.alert-warning').removeClass('d-none');
                this.Container.find('.message.alert-success').addClass('d-none');
                setTimeout(function() {
                    if( $('[data-group="pratique"].active .block-pratique-vote .message.alert-warning').length > 0 && $('[data-group="pratique"].active .block-pratique-vote .message.alert-warning').offset().top != 0 ) {
                        $("html, body").animate({scrollTop: _this.Container.find('.message.alert-warning').offset().top - 100}, 200);
                    }
                }, 800);
                this.Container.find('.candidat-vote').addClass('disabled');
                this.Container.find('.list-vote').addClass('disabled');
            } else if( this.bulletinVote.status == 'successful' ){
                this.Container.find('.note').text(this.total + " / " + this.total);
                this.Container.find('.message.alert-warning').addClass('d-none');
                this.Container.find('.message.alert-success').removeClass('d-none');
                setTimeout(function() {
                    if( $('[data-group="pratique"].active .block-pratique-vote .message.alert-success').length > 0 && $('[data-group="pratique"].active .block-pratique-vote .message.alert-success').offset().top != 0 ) {
                        $("html, body").animate({ scrollTop: _this.Container.find('.message.alert-success').offset().top - 100 }, 200 );
                    }
                }, 800);
                this.Container.find('.candidat-vote').addClass('disabled');
                this.Container.find('.list-vote').addClass('disabled');
            } else {
                this.Container.find('.message.alert-warning').addClass('d-none');
                this.Container.find('.message.alert-success').addClass('d-none');
                this.Container.find('.candidat-vote').removeClass('disabled');
                this.Container.find('.list-vote').removeClass('disabled');
            }

            $('.score_global').html(this.LetzvoteEuropeennes.score + " / " + this.LetzvoteEuropeennes.total);

        }



        vote_resolve(){

            this.load();

            this.bulletinVote.status = 'successful';
            this.LetzvoteEuropeennes.score += this.total;
            this.LetzvoteEuropeennes.trials.bulletinVote = this.total;

            if( this.bulletinVote.vote > 6 ){
                this.LetzvoteEuropeennes.score -= this.total;
                this.bulletinVote.status = 'failed';
                this.LetzvoteEuropeennes.trials.bulletinVote = 0;
            }
            if( this.bulletinVote.list > 1 ){
                this.LetzvoteEuropeennes.score -= this.total;
                this.bulletinVote.status = 'failed';
                this.LetzvoteEuropeennes.trials.bulletinVote = 0;
            }
            if( this.bulletinVote.list == 1 && this.bulletinVote.vote > 0 ){
                this.LetzvoteEuropeennes.score -= this.total;
                this.bulletinVote.status = 'failed';
                this.LetzvoteEuropeennes.trials.bulletinVote = 0;
            }
            if( this.bulletinVote.list == 0 && this.bulletinVote.vote == 0 ){
                this.LetzvoteEuropeennes.score -= this.total;
                this.bulletinVote.status = 'failed';
                this.LetzvoteEuropeennes.trials.bulletinVote = 0;
            }


            this.LetzvoteEuropeennes.number += 1;

            sessionStorage.setItem('LetzvoteEuropeennes', JSON.stringify(this.LetzvoteEuropeennes) );
            sessionStorage.setItem('EuropeennesVote', JSON.stringify(this.bulletinVote) );

            this.markup_vote();
        }

    }

    return new Vote();
}
